import React from 'react';

export default function Header() {
    return (
        <div className='header'>
            <img src="https://seeklogo.com/images/T/troll-face-logo-A3A07A678C-seeklogo.com.png" alt="troll_face" className='trollface'/>
            <h1 className='memeheading'>
                Meme Generator
            </h1>

        </div>
    )
}